<script setup lang="js">
import SubmitButton from '@/components/Forms/Buttons/SubmitButton.vue'
import BaseModal from '@/components/Alerts/BaseModal.vue'
import ObjectViewer from '@/components/Misc/ObjectViewer.vue'
import { ButtonSize, ButtonType } from '@/components/Forms/Buttons/SubmitButtonConstants.js'
import { useClipboard } from '@vueuse/core'
import { Toaster } from '@/models/utils/Toaster.js'

const props = defineProps({
	show: { type: Boolean, default: false },
	title: { type: String, default: '' },
	data: {
		type: [Object, null],
		required: true,
		default: null
	},
	start_collapsed: {
		type: Boolean,
		default: false
	},
	narrow_key:{
		type: Boolean,
		default: false
	},
	hide_key:{
		type: Boolean,
		default: false
	},
	allow_collapse:{
		type: Boolean,
		default: true
	}
})
const toaster = new Toaster();
const emit = defineEmits(['close']);

function copyText()
{
	useClipboard({ legacy: true }).copy(JSON.stringify(props.data, null, 2))

	toaster.success("Copied!")
}
</script>

<template>
	<BaseModal :show="show">
		<form class="flex flex-col max-h-[calc(100vh_-_8.125rem)] max-w-[calc(100vw_-_8.125rem)]">
			<div class="flex items-center space-x-2">
				<p class="text-xl font-bold text-heading">{{ props.title }}</p>
			</div>

			<ObjectViewer
				:data="props.data"
				:start_collapsed="props.start_collapsed"
				:narrow_key="props.narrow_key"
				:hide_key="props.hide_key"
				:allow_collapse="props.allow_collapse"
				:modal="true"
				class="w-full"
			/>

			<div class="flex flex-row mt-5 ml-auto space-x-4">
				<SubmitButton label="Copy Data" :type="ButtonType.Outline" :size="ButtonSize.Small" @click.prevent="copyText()" />
				<SubmitButton label="Ok" :type="ButtonType.Default" :size="ButtonSize.Small" @click.prevent="emit('close')" />
			</div>
		</form>
	</BaseModal>
</template>